import { Button } from "react-bootstrap";
import Modal from "../common/components/ThemedModal";
import { useLocation, useNavigate } from "react-router-dom";
import { Rider } from "../../types/model";
import AthleteProfileTemplate from "./AthleteProfileTemplate";
import { RiderHistoryItem } from "./athleteProfileUtils";
import { useAthleteProfileData } from "./useAthleteProfileData";

interface AthleteProfileModalProps {
	show: boolean;
	onHide: () => void;
	riderId?: string;
	riderName?: string;
	initialRider?: Rider | null;
	initialHistory?: RiderHistoryItem[];
}

const AthleteProfileModal = ({
	show,
	onHide,
	riderId,
	riderName,
	initialRider,
	initialHistory,
}: AthleteProfileModalProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const {
		rider,
		history,
		seasonHistory,
		seasonOptions,
		selectedSeasonKey,
		setSelectedSeasonKey,
		isLoading,
		error,
	} = useAthleteProfileData({
		riderId,
		enabled: show,
		initialRider,
		initialHistory,
	});

	const handleOpenProfilePage = () => {
		if (!riderId) {
			return;
		}
		onHide();
		navigate(`/riders/${riderId}`, {
			state: {
				fromPath: `${location.pathname}${location.search}`,
				fromLabel: "Riders",
			},
		});
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			size="xl"
			centered
			fullscreen="lg-down"
		>
			<Modal.Header closeButton>
				<Modal.Title>Athlete Profile</Modal.Title>
			</Modal.Header>
			<Modal.Body className="pt-0">
				<AthleteProfileTemplate
					rider={rider}
					riderNameFallback={riderName}
					history={history}
					seasonHistory={seasonHistory}
					seasonOptions={seasonOptions}
					selectedSeasonKey={selectedSeasonKey}
					onSeasonChange={setSelectedSeasonKey}
					isLoading={isLoading}
					error={error}
					actions={
						<Button
							variant="outline-primary"
							size="sm"
							onClick={handleOpenProfilePage}
							disabled={!riderId}
						>
							Open Full Page
						</Button>
					}
				/>
			</Modal.Body>
		</Modal>
	);
};

export default AthleteProfileModal;
